import React from 'react';
import PropTypes from 'prop-types';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import { DyzioPrimaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';
import { Grid, Divider, List, Icon } from 'semantic-ui-react';
import _ from 'lodash';

const nameSpanStyle = {
  fontSize: 20,
  fontWeight: 600,
  width: '100%',
};

const AudienceDataRequestHandlingModal = ({
  onClose,
  createdBy,
  agency,
  channels,
  onRequestAccepted,
  onRequestDeclined,
}) => (
  <DyzioModal
    headerText="Audience Data Request"
    onClose={onClose}
    size="small"
  >
    <span>
      {createdBy} from {agency.name} would like to view your audience data from the channels below. This will allowe
      her agency to view your channel demographics and audience size etc.
    </span>
    <Divider hidden />
    <Grid>
      <Grid.Row>
        <Grid.Column width={4} verticalAlign="middle">
          <h3>Agency</h3>
        </Grid.Column>
        <Grid.Column width={12} verticalAlign="middle">
          <span>
            <b style={nameSpanStyle}>{agency.name}</b>
          </span>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4} verticalAlign="middle">
          <h3>Channels</h3>
        </Grid.Column>
        <Grid.Column width={12} verticalAlign="middle">
          <List>
            {
              _.map(channels, (channel =>
                <List.Item>
                  <Grid verticalAlign="middle">
                    <Grid.Row>
                      <Grid.Column width={1}>
                        <Icon name={channel.channel} size="large" />
                      </Grid.Column>
                      <Grid.Column width={6}>
                        { _.upperFirst(channel.handle) }
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </List.Item>),
              )
            }
          </List>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns="two">
        <Grid.Column>
          <DyzioPrimaryButton
            label="Decline"
            fluid
            onClick={onRequestDeclined}
            color="pink"
            hasIcon
            icon={<Icon name="x" />}
          />

        </Grid.Column>
        <Grid.Column>
          <DyzioPrimaryButton
            label="Accept"
            fluid
            onClick={onRequestAccepted}
            color="green"
            hasIcon
            icon={<Icon name="checkmark" />}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </DyzioModal>
);

AudienceDataRequestHandlingModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  createdBy: PropTypes.string.isRequired,
  agency: PropTypes.object.isRequired,
  channels: PropTypes.array.isRequired,
  onRequestAccepted: PropTypes.func.isRequired,
  onRequestDeclined: PropTypes.func.isRequired,
};

export default AudienceDataRequestHandlingModal;



/** WEBPACK FOOTER **
 ** ./src/components/audience-data-request-handling-modal/index.js
 **/